import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "../../../../auth/AuthContext";
import { useTranslation } from "react-i18next";
import routes, { dashboardRoute } from "../../../../routes/routes";
import {
  AccountBalance,
  BarChart,
  Lock,
  Settings,
  TableRows,
} from "@mui/icons-material";

const NavigationContext = createContext(null);

export function NavigationProvider({ children }) {
  const { loadingActiveCompany, activeCompany, loadingUser } = useAuth();
  const { t } = useTranslation(["common", "settings", "vault", "navigation"]);
  const [elements, setElements] = useState(null);

  const init = () => {
    setElements([
      {
        title: t("navigation:tabs.dashboard.title"),
        subheading: t("navigation:tabs.dashboard.subheading"),
        path: dashboardRoute,
        icon: <TableRows />,
        hidden: !activeCompany || activeCompany.is_reseller,
      },
      {
        title: t("navigation:tabs.dashboard.title"),
        subheading: t("navigation:tabs.dashboard.subheadingReseller"),
        path: routes.Reseller.clients,
        icon: <TableRows />,
        hidden: !activeCompany || !activeCompany.is_reseller,
      },
      {
        title: t("navigation:tabs.loans.title"),
        subheading: t("navigation:tabs.loans.subheading"),
        path: routes.Financing.loans,
        icon: <AccountBalance />,
        hidden: !activeCompany || activeCompany.is_reseller,
      },
      {
        title: t("navigation:tabs.vault.title"),
        subheading: t("navigation:tabs.vault.subheading"),
        path: routes.Vault.root,
        icon: <Lock />,
        hidden: !activeCompany,
      },
      {
        title: t("navigation:tabs.treasury.title"),
        subheading: t("navigation:tabs.treasury.subheading"),
        path: routes.Treasury.root,
        icon: <BarChart />,
        hidden:
          !activeCompany ||
          activeCompany.is_reseller ||
          !activeCompany.has_open_banking,
      },
      {
        title: t("navigation:tabs.settings.title"),
        subheading: t("navigation:tabs.settings.subheading"),
        path: routes.Settings.profile,
        icon: <Settings />,
      },
    ]);
  };

  useEffect(() => {
    if (!loadingActiveCompany || !loadingUser) {
      init();
    }
  }, []);

  const value = {
    loading: loadingActiveCompany || loadingUser,
    elements,
  };

  return <NavigationContext value={value}>{children}</NavigationContext>;
}

export function useNavigationContext() {
  return useContext(NavigationContext);
}
